"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isTimingSummaryValid = isTimingSummaryValid;
exports.searchAllowedCharacters = searchAllowedCharacters;
exports.validateDateAndTimeSearch = validateDateAndTimeSearch;
var _dateFns = require("date-fns");
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _differenceInHours = _interopRequireDefault(require("date-fns/differenceInHours"));
var _differenceInMinutes = _interopRequireDefault(require("date-fns/differenceInMinutes"));
var _differenceInYears = _interopRequireDefault(require("date-fns/differenceInYears"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _getDay = _interopRequireDefault(require("date-fns/getDay"));
var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));
var _roundToNearestMinutes = _interopRequireDefault(require("date-fns/roundToNearestMinutes"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _getKSADate = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/store/getKSADate"));
var _getSpecialTimingProps = _interopRequireDefault(require("../date/getSpecialTimingProps"));
var _isToday = _interopRequireDefault(require("../date/isToday"));
var _isValidDropOff = _interopRequireDefault(require("../isValidDropOff"));
var _DATE_TIME_PICKER = _interopRequireDefault(require("../../constants/date/DATE_TIME_PICKER"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Checks Allowed Characters for the search Input to allow only letters, numbers, space, hyphen, apostrophes and Ampersand
 * @param {string} text
 * @returns {boolean}
 */
function searchAllowedCharacters(text) {
  return !/[^A-Za-z\u0621-\u064A\u0660-\u0669 \-\'\&\d]/.test(text);
}

/**
 * Function to check if the passed date is an off day
 * @param {Date} date
 * @param {Array} offDays
 * @returns {boolean} true if it is an off day
 */
function isBranchClosed(date, offDays) {
  var dayOfWeek = (0, _getDay["default"])(date);
  var isOffDay = offDays.indexOf(dayOfWeek) !== -1;
  return isOffDay;
}

/**
 * Function check if the date fall in holidays
 * @param {Date} date
 * @param {Array} holidays
 * @returns {boolean} true if it is holiday
 */
var isHoliday = function isHoliday(date, holidays) {
  return holidays.some(function (offDay) {
    return (0, _isSameDay["default"])(offDay, date);
  });
};

/**
 * Function to check if the Time Summary Time is available
 * @param {String} time // e.g  09:00 AM
 * @param {Array} timingSummary
 * @returns {boolean} true if it is an off day
 */
function isTimingSummaryValid(time, timingSummary) {
  var formattedToday = (0, _format["default"])((0, _getKSADate["default"])(new Date()), 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedSelectedTime = new Date("".concat(formattedToday, " ").concat(time));
  var epochSelectedTime = (0, _dateFns.getTime)(formattedSelectedTime);
  var isTimeInSummary = timingSummary === null || timingSummary === void 0 ? void 0 : timingSummary.filter(function (item) {
    var _item$timeRanges;
    return item === null || item === void 0 || (_item$timeRanges = item.timeRanges) === null || _item$timeRanges === void 0 ? void 0 : _item$timeRanges.some(function (slot) {
      // '12:00 AM - 2:00 PM'
      var _slot$split = slot.split('-'),
        _slot$split2 = _slicedToArray(_slot$split, 2),
        start = _slot$split2[0],
        end = _slot$split2[1];
      var selectedOpenTime4 = new Date("".concat(formattedToday, " ").concat(start));
      var epochOpenTime = (0, _dateFns.getTime)(selectedOpenTime4);
      var selectedCloseTime4 = new Date("".concat(formattedToday, " ").concat(end));
      var epochCloseTime = (0, _dateFns.getTime)(selectedCloseTime4);
      var diff1 = epochSelectedTime - epochOpenTime;
      var diff2 = epochCloseTime - epochSelectedTime;
      return diff1 >= 0 && diff2 >= 0;
    });
  });
  return !!isTimeInSummary.length;
}

/**
 * Function to check if passed time is within opening and closing times
 * @param {string} time in 12 hrs format
 * @param {Date} date
 * @param {Object} onDays
 * @returns {boolean}
 */

function isTimeValid(time, date, onDays, timingSummary) {
  // console.log('** time: ', time);
  // console.log('** date: ', date);
  var dayOfWeek = (0, _getDay["default"])(date);
  var selectedDayTiming = (0, _get2["default"])(onDays, "".concat(dayOfWeek), {});
  // console.log('** selectedDayTiming: ', selectedDayTiming);
  var is24hr = selectedDayTiming.is24hr,
    start = selectedDayTiming.start,
    end = selectedDayTiming.end,
    isMultiTimeSlot = selectedDayTiming.isMultiTimeSlot;
  // if it is a 24hr branch for the selected date then the time is valid anyways
  if (is24hr) {
    return true;
  }

  // check if the selected time is within open and close times
  // using today as a fake formatter. we just need the time value
  var formattedToday = (0, _format["default"])((0, _getKSADate["default"])(new Date()), 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedOpenTime = new Date("".concat(formattedToday, " ").concat(start));
  var formattedCloseTime = new Date("".concat(formattedToday, " ").concat(end));
  var formattedSelectedTime = new Date("".concat(formattedToday, " ").concat(time));

  // console.log({
  //   formattedOpenTime,
  //   formattedCloseTime,
  //   start,
  //   end,
  //   formattedSelectedTime,
  // });
  if (isMultiTimeSlot) {
    return isTimingSummaryValid(time, timingSummary);
  }
  var diff1 = (0, _differenceInMinutes["default"])(formattedSelectedTime, formattedOpenTime); // diff between selected time and open time
  var diff2 = (0, _differenceInMinutes["default"])(formattedCloseTime, formattedSelectedTime); // diff between close time and selected time
  // console.log(diff1);
  // console.log(diff2);
  // selected time is valid if both differences are 0 or +ve
  return diff1 >= 0 && diff2 >= 0;
}

/**
 * Function to check if pickup time and dropoff time are atleast 30 mins apart if
 * pickup and dropoff dates are same
 * @param {string} pickupTime in 12 hrs format
 * @param {string} dropoffTime in 12 hrs format
 * @returns {boolean}
 */
function is30MinsApart(pickupTime, dropoffTime) {
  // using today as a fake formatter. we just need the time value
  var formattedToday = (0, _format["default"])((0, _getKSADate["default"])(new Date()), 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedPickupTime = new Date("".concat(formattedToday, " ").concat(pickupTime));
  var formattedDropoffTime = new Date("".concat(formattedToday, " ").concat(dropoffTime));
  var diff = (0, _differenceInMinutes["default"])(formattedDropoffTime, formattedPickupTime);
  return diff >= _DATE_TIME_PICKER["default"].MINS_APART;
}

/**
 * Function to check if pickup date is not more than 90 days
 * @param {Date} pickupDate
 * @returns {boolean}
 */
function isPickupDateValid(pickupDate, pickupTime) {
  // pickup date cannot be more than 90 days in future from today + current time
  // convert to ksa time zone
  var pickupWindow = (0, _addDays["default"])((0, _getKSADate["default"])(new Date()), _DATE_TIME_PICKER["default"].MAX_PICKUP);
  var formattedDate = (0, _format["default"])(pickupDate, 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedDateTime = new Date("".concat(formattedDate, " ").concat(pickupTime));
  // if it is <=0 then pickup date is within the window and is valid
  var diff = (0, _differenceInMinutes["default"])(formattedDateTime, pickupWindow);
  return diff <= 0;
}

/**
 * Function to check if total rental duration is not more than 365 days from pickup date + time
 * @param {Date} pickupDate
 * @param {string} pickupTime in 12 hrs format
 * @param {Date} dropoffDate
 * @param {string} dropoffTime in 12 hrs format
 * @returns {boolean}
 */
function isRentalDurationValid(pickupDate, pickupTime, dropoffDate, dropoffTime) {
  var formattedPickupDate = (0, _format["default"])(pickupDate, 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedPickupDateTime = new Date("".concat(formattedPickupDate, " ").concat(pickupTime));
  var formattedDropoffDate = (0, _format["default"])(dropoffDate, 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedDropoffDateTime = new Date("".concat(formattedDropoffDate, " ").concat(dropoffTime));
  // if it is <=0 then rental duration is within 365 days from pickup date + time
  var diff = (0, _differenceInYears["default"])(formattedDropoffDateTime, formattedPickupDateTime);
  return diff <= 0;
}

/**
 * Function to check if pickup time is > T + Lead time (from curr time)
 * If pickup date is today
 * @param {string} pickupTime in 12 hrs format
 * @param {number} leadTime in minutes
 * @returns {boolean}
 */
function isTPlusLeadTime(pickupTime, leadTime) {
  // convert to ksa time zone
  var ksaToday = (0, _getKSADate["default"])(new Date());
  var formattedToday = (0, _format["default"])(ksaToday, 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var pickupDateTime = new Date("".concat(formattedToday, " ").concat(pickupTime));
  // check from now if it is t+LeadTime
  // rounded to the nearest 30 mins
  var roundedLeadTime = (0, _roundToNearestMinutes["default"])(ksaToday, {
    nearestTo: _DATE_TIME_PICKER["default"].SLOT_INTERVAL
  });
  // if it is >=LeadTime then pickup time is atleast T+LeadTime from current time
  var diff = (0, _differenceInHours["default"])(pickupDateTime, roundedLeadTime);
  // convert leadTime to hours
  var leadTimeInHours = leadTime / 60;
  return diff >= leadTimeInHours;
}

/**
 * Validates the branch search data/time on click of search button
 *  Validates pickup date, pickup time, dropoff date, dropoff time
 *  for selected pickup and dropoff branch.
 * @param {Object} searchObj
 * @returns {object}
 */

function validateDateAndTimeSearch(searchObj) {
  var pickupBranch = searchObj.pickupBranch,
    dropoffBranch = searchObj.dropoffBranch,
    pickupDate = searchObj.pickupDate,
    dropoffDate = searchObj.dropoffDate,
    pickupTime = searchObj.pickupTime,
    dropoffTime = searchObj.dropoffTime,
    isSameDay = searchObj.isSameDay;

  // 1. check if pickup branch is open on pickup date
  var pickupOffDays = (0, _get2["default"])(pickupBranch, 'offDays', []);
  var pickupHolidays = (0, _get2["default"])(pickupBranch, 'holidays', []);
  var isPickupBranchClosed = isBranchClosed(pickupDate, pickupOffDays) || isHoliday(pickupDate, pickupHolidays);
  // console.log('** is pickup branch open: ', !isPickupBranchClosed);

  // 2. check if dropoff branch is open on dropoff date
  var dropoffOffDays = (0, _get2["default"])(dropoffBranch, 'offDays', []);
  var dropoffHolidays = (0, _get2["default"])(dropoffBranch, 'holidays', []);
  var isDropoffBranchClosed = isBranchClosed(dropoffDate, dropoffOffDays) || isHoliday(dropoffDate, dropoffHolidays);
  // console.log('** is dropoff branch open: ', !isDropoffBranchClosed);

  // 3. check if pick up time is within opening and closing time for the pickup date
  // check if pickup date/time fall in special timing days
  var pickupSpecialTimings = (0, _get2["default"])(pickupBranch, 'specialTimings', []);
  var _getSpecialTimingProp = (0, _getSpecialTimingProps["default"])(pickupSpecialTimings, pickupDate),
    isPickupSpecialDay = _getSpecialTimingProp.isTodaySpecialDay,
    pickupSpecialTimingWeek = _getSpecialTimingProp.specialTimingWeek,
    pickupSpecialOnDays = _getSpecialTimingProp.specialOnDays;
  var pickupOnDays = isPickupSpecialDay ? pickupSpecialOnDays : (0, _get2["default"])(pickupBranch, 'onDays', {});
  var pickupTimingSummary = isPickupSpecialDay ? pickupSpecialTimingWeek : (0, _get2["default"])(pickupBranch, 'timingSummary', []);

  // console.log({ pickupOnDays });
  var isPickupTimeValid = isTimeValid(pickupTime, pickupDate, pickupOnDays, pickupTimingSummary);

  // console.log('** isPickupTimeValid: ', isPickupTimeValid);

  // 4. check if drop off time is within opening and closing time for dropoff date
  // check if dropoff date/time fall in special timing days
  var dropoffSpecialTimings = (0, _get2["default"])(dropoffBranch, 'specialTimings', []);
  var _getSpecialTimingProp2 = (0, _getSpecialTimingProps["default"])(dropoffSpecialTimings, dropoffDate),
    isDropoffSpecialDay = _getSpecialTimingProp2.isTodaySpecialDay,
    dropoffSpecialTimingWeek = _getSpecialTimingProp2.specialTimingWeek,
    dropoffSpecialOnDays = _getSpecialTimingProp2.specialOnDays;
  var dropoffOnDays = isDropoffSpecialDay ? dropoffSpecialOnDays : (0, _get2["default"])(dropoffBranch, 'onDays', {});
  var dropoffTimingSummary = isDropoffSpecialDay ? dropoffSpecialTimingWeek : (0, _get2["default"])(dropoffBranch, 'timingSummary', []);
  var isDropoffTimeValid = isTimeValid(dropoffTime, dropoffDate, dropoffOnDays, dropoffTimingSummary);
  // console.log('** isDropoffTimeValid: ', isDropoffTimeValid);

  // 5. check if pickup and dropoff times are 30 mins apart if pickup and dropoff dates are same
  var isMinDurationValid = isSameDay ? is30MinsApart(pickupTime, dropoffTime) : true;
  // console.log('** is 30 mins apart: ', isMinDurationValid);

  // 6. check if pickup date is today, then pickup time is atleast T + LeadTime from now
  var leadTimeMinutes = (0, _get2["default"])(pickupBranch, 'leadTimeMinutes', _DATE_TIME_PICKER["default"].T_PLUS_240_M);
  var isTPlusLeadTimeValid = (0, _isToday["default"])(pickupDate) ? isTPlusLeadTime(pickupTime, leadTimeMinutes) : true;
  // console.log('** pick up time is T+LeadTime: ', isTPlusLeadTimeValid);

  return {
    isPickupBranchClosed: isPickupBranchClosed,
    isDropoffBranchClosed: isDropoffBranchClosed,
    isPickupTimeValid: isPickupTimeValid,
    isDropoffTimeValid: isDropoffTimeValid,
    isMinDurationValid: isMinDurationValid,
    isTPlusLeadTimeValid: isTPlusLeadTimeValid
  };
}

/**
 * Validates the branch search data on click of search button
 *  Validates pickup date, pickup time, dropoff date, dropoff time
 *  for selected pickup and dropoff branch.
 * @param {Object} searchObj
 * @returns {boolean}
 *  Returns true if search params are valid
 *  Else returns false
 */
function validateSearch(searchObj) {
  var pickupBranch = searchObj.pickupBranch,
    dropoffBranch = searchObj.dropoffBranch,
    pickupDate = searchObj.pickupDate,
    dropoffDate = searchObj.dropoffDate,
    pickupTime = searchObj.pickupTime,
    dropoffTime = searchObj.dropoffTime,
    isSameDay = searchObj.isSameDay,
    isDeliveryTabActive = searchObj.isDeliveryTabActive,
    minDaysOfDeliveryDropOff = searchObj.minDaysOfDeliveryDropOff;
  // console.log('** searchObj: ', searchObj);

  // check pick-up/drop-off date/time validation.
  var _validateDateAndTimeS = validateDateAndTimeSearch({
      pickupBranch: pickupBranch,
      dropoffBranch: dropoffBranch,
      pickupDate: pickupDate,
      dropoffDate: dropoffDate,
      pickupTime: pickupTime,
      dropoffTime: dropoffTime,
      isSameDay: isSameDay
    }),
    isPickupBranchClosed = _validateDateAndTimeS.isPickupBranchClosed,
    isDropoffBranchClosed = _validateDateAndTimeS.isDropoffBranchClosed,
    isPickupTimeValid = _validateDateAndTimeS.isPickupTimeValid,
    isDropoffTimeValid = _validateDateAndTimeS.isDropoffTimeValid,
    isMinDurationValid = _validateDateAndTimeS.isMinDurationValid,
    isTPlusLeadTimeValid = _validateDateAndTimeS.isTPlusLeadTimeValid;

  // 7. check if pickup date is not more than 90 days in future
  var isPickupValid = isPickupDateValid(pickupDate, pickupTime);
  // console.log('** pickup not more than 90 days (incl time): ', isPickupValid);

  // 8. check if total rental duration is not more than 365 days
  var isRentalValid = isRentalDurationValid(pickupDate, pickupTime, dropoffDate, dropoffTime);
  // console.log(
  //   '** total rental duration is not more than 365 days (incl time): ',
  //   isRentalValid,
  // );

  // 9. check if drop off date is more than x days in future for delivery branches
  var isDeliveryDropOffValid = isDeliveryTabActive ? (0, _isValidDropOff["default"])(pickupDate, dropoffDate, minDaysOfDeliveryDropOff) : true;
  // console.log(
  //   `** dropOff date is more than ${minDaysOfDeliveryDropOff} days in future for delivery branches `,
  //   isDeliveryDropOffValid,
  // );

  return !isPickupBranchClosed && !isDropoffBranchClosed && isPickupTimeValid && isDropoffTimeValid && isMinDurationValid && isTPlusLeadTimeValid && isPickupValid && isRentalValid && isDeliveryDropOffValid;
}
var _default = exports["default"] = validateSearch;